module.exports = __webpack_public_path__ + "static/img/banner.8903035.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_10/banner.jpg
// module id = Ou/8
// module chunks = 0